<template>
  <div id="modalCreateEditBoard" class="modal fade" tabindex="-1">
    <div class="modal-dialog modal-sm">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{ textModal }} Quadro</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            title="Fechar"
            @click="$emit('closeModal', false)"
          />
        </div>
        <form @submit.prevent="save">
          <div class="modal-body">
            <div class="row g-3">
              <div class="col-sm-12">
                <label class="form-label">
                  Ninja ID: <span class="text-danger">*</span>
                </label>
                <input
                  type="text"
                  class="form-control"
                  :class="{ 'is-invalid': v$.board.ninjaId.$errors.length }"
                  placeholder="ID do Quadro no Ninja"
                  v-model="v$.board.ninjaId.$model"
                />
                <span
                  v-if="
                    v$.board.ninjaId.required.$invalid &&
                    v$.board.ninjaId.$errors.length
                  "
                  class="invalid-feedback"
                >
                  O campo é obrigatório
                </span>
              </div>
              <div class="col-sm-12">
                <label class="form-label">
                  Nome: <span class="text-danger">*</span>
                </label>
                <input
                  type="text"
                  class="form-control"
                  :class="{ 'is-invalid': v$.board.name.$errors.length }"
                  placeholder="Nome do Quadro"
                  v-model="v$.board.name.$model"
                />
                <span
                  v-if="
                    v$.board.name.required.$invalid &&
                    v$.board.name.$errors.length
                  "
                  class="invalid-feedback"
                >
                  O campo é obrigatório
                </span>
              </div>
              <div class="col-sm-12">
                <label class="form-label">
                  Status: <span class="text-danger">*</span>
                </label>
                <select class="form-select" v-model="v$.board.status.$model">
                  <option value="" disabled>Selecione</option>
                  <option
                    v-for="option in statusOptions"
                    :key="option.value"
                    :value="option.value"
                  >
                    {{ option.text }}
                  </option>
                </select>
              </div>
            </div>
          </div>
          <div class="modal-footer border-top-0">
            <button
              type="button"
              class="btn btn-link"
              data-bs-dismiss="modal"
              title="Cancelar"
              @click="$emit('closeModal', false)"
            >
              Cancelar
            </button>
            <button
              type="submit"
              class="btn btn-primary"
              :title="textModal"
              :disabled="v$.$invalid || disableButton"
            >
              <span v-if="disableButton">
                <i class="ph ph-spinner spinner" />
              </span>
              <span v-else>{{ textModal }}</span>
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { useVuelidate } from '@vuelidate/core'
import { required } from '@vuelidate/validators'
import { showModal, hideModal } from '@/utils/modal'

export default {
  name: 'CreateEditBoardModal',

  props: {
    boardId: {
      type: String,
      default: null,
    },
  },

  setup() {
    return { v$: useVuelidate() }
  },

  data() {
    return {
      board: {
        ninjaId: '',
        name: '',
        status: 1,
      },
      statusOptions: [
        { value: 1, text: 'Ativo' },
        { value: 0, text: 'Inativo' },
      ],
      disableButton: false,
    }
  },

  computed: {
    textModal() {
      return this.boardId ? 'Atualizar' : 'Cadastrar'
    },
  },

  methods: {
    async getBoard() {
      try {
        this.board = await this.$store.dispatch('getBoard', this.boardId)
        showModal('modalCreateEditBoard')
      } catch (error) {
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
        this.$emit('closeModal', false)
      }
    },

    async save() {
      if (!this.v$.$invalid) {
        this.disableButton = true
        try {
          let response = null

          if (this.boardId) {
            response = await this.$store.dispatch('updateBoard', {
              id: this.boardId,
              board: this.board,
            })
          } else {
            response = await this.$store.dispatch('createBoard', this.board)
          }

          hideModal()
          this.$emit('closeModal', true)
          this.$root.$refs.notification.success(response.message)
        } catch (error) {
          this.disableButton = false
          if (error && error.message) {
            this.$root.$refs.notification.warning(error.message)
          } else {
            this.$root.$refs.notification.error(
              'Não foi possível se conectar ao servidor.',
            )
          }
        }
      }
    },
  },

  validations() {
    return {
      board: {
        ninjaId: {
          required,
        },
        name: {
          required,
        },
        status: {
          required,
        },
      },
    }
  },

  mounted() {
    if (this.boardId) {
      this.getBoard()
    } else {
      showModal('modalCreateEditBoard')
    }
  },
}
</script>
